import axios from 'axios'

function endpoint(path = '') {
  const base = process.env.VUE_APP_BASE_URL || ''
  return `${base}/semantic-search/collections${path}`
}

export function listHighlightCollections() {
  return axios.get(endpoint(), { timeout: 30000 })
}

export function createHighlightCollection(payload) {
  return axios.post(endpoint(), payload, { timeout: 30000 })
}

export function getHighlightCollection(collectionId) {
  return axios.get(endpoint(`/${encodeURIComponent(collectionId)}`), {
    timeout: 30000,
  })
}

export function updateHighlightCollection(collectionId, payload) {
  return axios.patch(
    endpoint(`/${encodeURIComponent(collectionId)}`),
    payload,
    { timeout: 30000 }
  )
}

export function addHighlightCollectionItem(collectionId, payload) {
  return axios.post(
    endpoint(`/${encodeURIComponent(collectionId)}/items`),
    payload,
    { timeout: 30000 }
  )
}

export function removeHighlightCollectionItem(collectionId, itemId) {
  return axios.delete(
    endpoint(
      `/${encodeURIComponent(collectionId)}/items/${encodeURIComponent(itemId)}`
    ),
    { timeout: 30000 }
  )
}

export function updateHighlightCollectionItem(collectionId, itemId, payload) {
  return axios.patch(
    endpoint(
      `/${encodeURIComponent(collectionId)}/items/${encodeURIComponent(itemId)}`
    ),
    payload,
    { timeout: 30000 }
  )
}

export function prepareHighlightCollection(collectionId) {
  return axios.post(
    endpoint(`/${encodeURIComponent(collectionId)}/prepare`),
    {},
    { timeout: 30000 }
  )
}
